// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/account": [4],
		"/account/confirm-user/[userId]/[code]": [5],
		"/account/profile": [6],
		"/admin/base-data/line": [7],
		"/admin/base-data/pole": [8],
		"/admin/companies/[[company_id]]/user/new": [11],
		"/admin/companies/[[company_id]]/user/[user_id]": [10],
		"/admin/companies/[[company_id]]": [9],
		"/admin/data-management": [12],
		"/admin/globals": [13],
		"/auth": [14],
		"/condition-templates": [15],
		"/dashboards/aviationobstacles": [16],
		"/login": [17],
		"/logout": [18],
		"/map": [19],
		"/reports/mastpoint-damage-report": [20],
		"/reports/mastpoint-report": [21],
		"/reports/new-capacity-report": [22],
		"/reports/plan-condition-report": [23],
		"/reports/pole-capacity-report": [24],
		"/reports/polygon-capacity-report": [25],
		"/reports/polygon-section-calculation": [26],
		"/smartdata": [27,[2]],
		"/smartdata/images": [28,[2]],
		"/smartdata/images/all": [30,[2]],
		"/smartdata/images/inspections": [31,[2]],
		"/smartdata/images/search": [32,[2]],
		"/smartdata/images/uncategorized": [33,[2]],
		"/smartdata/images/[...path]": [29,[2]],
		"/smartdata/pointclouds": [34,[2]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);